import React from "react";
import { Link } from "react-router-dom";

export default function Sports() {
  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title-section bg-img cover-background top-position1 left-overlay-secondary"
        data-overlay-dark="85"
        style={{ backgroundImage: 'url("img/banner/page-title-sports.jpg")' }}
      >
        <div className="container">
          <div className="row position-relative z-index-9">
            <div className="col-md-12">
              <h1>Sports</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Sports</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Content */}
      <section>
        <div className="container">
          <div className="row mt-n2-9">
            {/* Sidebar */}
            <div className="col-lg-4 mt-2-9 order-2 order-lg-1">
              <div className="sidebar me-xl-1-9">
                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Our Work</h2>
                  <ul className="list-unstyled menu m-0">
                    {[
                      {
                        name: "Skill Development",
                        to: "/skill-development",
                      },
                      { name: "Education", to: "/education" },
                      { name: "Health", to: "/health" },
                      {
                        name: "Inclusion of Differently Abled",
                        to: "/abled",
                      },
                      { name: "Sports", to: "/sports", active: true },
                      {
                        name: "Community Initiatives",
                        to: "/community-initiatives",
                      },
                      { name: "Livelihoods", to: "/livelihoods" },
                    ].map((item, idx) => (
                      <li key={idx} className={item.active ? "active" : ""}>
                        <Link to={item.to}>
                          {item.name}
                          <i className="ti-arrow-right"></i>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                <div
                  className="widget mb-1-9 wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <h2 className="mb-4 h4">Follow us</h2>
                  <ul className="social-icon-style2 list-unstyled ps-0">
                    <li className="me-1 d-inline-block"><Link to="https://www.facebook.com/www.shamayitamath.org?mibextid=ZbWKwL"target="blank"><i className="fab fa-facebook-f"></i></Link></li>
                    <li className="me-1 d-inline-block"><Link to="https://youtube.com/@shamayitamath2956?si=s7HKE99MD6pY6Kpb"target="blank"><i className="fa-brands fa-youtube"></i></Link></li>
                    <li className="me-1 d-inline-block"><Link to="https://www.instagram.com/shamayitamath?utm_source=ig_web_button_share_sheet&igsh=ODdmZWVhMTFiMw=="target="blank"><i className="fab fa-instagram"></i></Link></li>
                    <li className="me-0 d-inline-block"><Link to="https://www.linkedin.com/company/shamayitamath/?viewAsMember=true"target="blank"><i className="fab fa-linkedin-in"></i></Link></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-8 mt-2-9 order-1 order-lg-2">
              <div>
                {/* Main Image */}
                <div
                  className="mb-1-9 mb-lg-5 image-hover wow fadeInUp"
                  data-wow-delay="100ms"
                >
                  <img
                    src="img/service/service-details-sports.jpg"
                    alt="..."
                    className="border-radius-10"
                  />
                </div>

                {/* Intro Paragraph */}
                <p className="mb-3 wow fadeInUp" data-wow-delay="100ms">
                  Acknowledging the power of sports, especially team sports, as
                  a strong medium to bring about robust physical and mental
                  growth of the children while promoting bonding,
                  self-confidence, resilience, and creativity, Shamayita Math
                  has evolved Shamayita Sports Academy (SSA). It works to
                  identify and develop local talent, especially from excluded
                  groups including tribal communities, in the game of football.
                </p>

                {/* Section 1 */}
                <h2 className="mb-4 wow fadeInUp text-primary pt-3" data-wow-delay="100ms">Shamayita Math Sports Academy:</h2>

                  <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                    Commitment to Underprivileged Youth:
                  </h4>

                  <div className="row align-items-center mb-1-9">
                    <div className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp" data-wow-delay="100ms">
                      <div className="image-hover">
                        <img
                          src="img/service/sports-3.jpg"
                          alt="..."
                          className="border-radius-10"
                        />
                      </div>
                    </div>
                    <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                      <p className="mb-0">
                        Shamayita Math set up its sports academy in 2010 to enable 5- to 18-year-olds to access facilities and training in football and make a career in the sport. For this, the academy scouts and develops untrained sports talent, particularly from deprived backgrounds. The academy places a special focus on developing women footballers.
                      </p>
                    </div>
                    <p className="mb-0">
                      Through awareness and motivation among girls, parents, and communities, it has enabled young girls to successfully surmount challenges such as high dropout rates and early marriages. The boys and girls have been doing well and many of them have gone on to play at the state and national levels.
                    </p>
                  </div>

                {/* Section 2 */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Special weekend football school:
                </h4>
                <div className="row align-items-center mb-1-9">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p>
                      The Special Weekend Football School conducts practice sessions three days a week for boys and girls separately, with rigorous weekend coaching in a residential mode. The program includes workouts, field practice, theoretical classes, and proper nutrition, all delivered by licensed football coaches. Through this initiative, rural sports meets and football tournaments are organized, along with special coaching camps for women. The initiative aims to identify and nurture rural youth into professional football players capable of competing at state and national levels.
                    </p>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/sports-4.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>

                {/* Section 3 */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Affiliation and Training Programs:
                </h4>

                <div className="row align-items-center mb-1-9">
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/sports-5.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <p>
                      The SSA is affiliated with reputed associations including
                      the District Sports Association, Bankura. The trainees are
                      categorized into Grass Root (6-12 years) and Senior Group
                      (13-19 years). Moreover, SSA’s football coaching program
                      is linked with the All-India Football Federation (IFA,
                      West Bengal). It is also eligible to participate in the
                      Premier division in the District League, where it has been
                      the winner and runner-up several times.
                    </p>
                  </div>
                </div>

                {/* Section 4 - Facilities */}
                <h4 className="mb-4 wow fadeInUp pt-3" data-wow-delay="100ms">
                  Facilities:
                </h4>
                <div className="row align-items-center mb-1">
                  <div className="col-xl-6 wow fadeInUp" data-wow-delay="100ms">
                    <ul className="list-unstyled list-style02 last">
                      <li>International size grassy football ground- Shamayita Krirangan</li>
                      <li>Residential training during weekends with proper nutrition and separate coaching sessions for boys and girls</li>
                      <li>Licensed football coaches provide structured workouts, field practice, and theoretical classes</li>
                      <li>International size grassy football ground with change rooms.</li>
                      <li>Access to best of the football accessories.</li>
                    </ul>
                  </div>
                  <div
                    className="col-xl-6 mb-4 mb-xl-0 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="image-hover">
                      <img
                        src="img/service/sports-6.jpg"
                        alt="..."
                        className="border-radius-10"
                      />
                    </div>
                  </div>
                </div>
                <ul className="list-unstyled list-style02 last">
                  <li>
                    Regular conditioning camps and comfortable tours for
                    football tournaments at the all-India level.
                  </li>
                </ul>

                {/* Section 5 - Impacts */}
                <h4 className="mb-4 wow fadeInUp" data-wow-delay="100ms">
                  Impacts:
                </h4>
                <div className="row mb-1-9 wow fadeInUp" data-wow-delay="100ms">
                  <div className="col-md-12 mb-4 mb-md-0">
                    {[
                      "Empowerment and inclusion of youth from marginalized communities by helping them attain their football dreams",
                      "Young girls pursuing the sport... are today harboring dreams of playing football professionally.",
                      "The initiative is gradually breaking gender stereotypes and changing society’s mindsets towards girls’ participation in sports.",
                      "The youth playing football are becoming role models for many younger children in the area.",
                      "They develop qualities such as fitness, teamwork, life skills, and much more leading to an evolved life.",
                    ].map((text, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center border border-color-light-black p-2 mb-3"
                      >
                        <i className="fa-solid fa-circle-check display-26 text-primary"></i>
                        <span className="ms-3 text-dark fw-bold">{text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="scroll-top-percentage">
          <span id="scroll-value"></span>
        </div>
      </section>
    </>
  );
}
